/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TabWidgetConfiguration extends models.WidgetConfiguration {
    constructor() {
        super();
        this.setDiscriminator("TabWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return TabWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<TabWidgetConfiguration>): TabWidgetConfiguration {
        let obj = Object.assign(new TabWidgetConfiguration(), model);
        TabWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TabWidgetConfiguration>): TabWidgetConfiguration {
        if (!model) return null;
        return TabWidgetConfiguration.newInstance(<TabWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TabWidgetConfiguration) {
        if (!obj) return;

        models.TabWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TabWidgetConfiguration): boolean {
        if (models.WidgetConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TabWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.numCols === undefined) {
            this.numCols = 0;
        }
        if (this.numRows === undefined) {
            this.numRows = 0;
        }
        if (this.tabs) {
            for (let val of this.tabs) {
                models.WidgetTab.fixupPrototype(val);
            }
        }
    }

    numCols: number;

    numRows: number;

    tabs: Array<models.WidgetTab>;

}
